<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
    <h1 class="tw-text-lg">
      Pinia Example
    </h1>
    <p>
      {{ exampleStore.count }} * 3 = {{ exampleStore.tripled }}
    </p>
    <PiniaExampleComponent />
  </div>
</template>


<script>
import PiniaExampleComponent from './PiniaExampleComponent.vue';

// We use mapStores because we are using the Vue Options API
// Syntax is a little different if using the Composition API
import { mapStores } from 'pinia';
import { useExampleStore } from '@frontend/ui/stores/exampleStore';

export default {
  name: 'PiniaExampleView',
  components: { PiniaExampleComponent },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */

    // Makes the entire store available
    ...mapStores(useExampleStore),
    // For other situations with the Options API see
    // https://pinia.vuejs.org/cookbook/options-api.html
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
